// 파트너 입찰(1억이하)
export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-insider",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace-insider",
      },
    ],
  },
  {
    url: "/tab/101",
    name: "안전·보건 경영방침",
    icon: "",
    activeCode: "",
    groupName: ["101"],
  },
  {
    url: "/",
    name: "안전·보건 조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/126",
        name: "안전·보건조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/436",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["436"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/434",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["434"],
      },
    ],
  },
  {
    url: "/",
    name: "근골격계 유해요인조사",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/293",
        name: "근골격계부담작업 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["293"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/100",
        name: "안전·보건 합동점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/439",
        name: "안전 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["439"],
      },
      {
        url: "/tab/290",
        name: "보건 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["290"],
      },
      {
        url: "/tab/438",
        name: "휴게시설 주요 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["438"],
      },
      {
        url: "/tab/580",
        name: "신호 및 연락체계",
        icon: "w-line",
        activeCode: "",
        groupName: ["580"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가(3등급)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/475",
        name: "3등급(상·중·하) 판단법",
        icon: "w-line",
        activeCode: "",
        groupName: ["475"],
      },
      {
        url: "/tab/476",
        name: "주간 이행사항 점검 및 회의",
        icon: "w-line",
        activeCode: "",
        groupName: ["476"],
      },
      {
        url: "/tab/477",
        name: "일일TBM 활동",
        icon: "w-line",
        activeCode: "",
        groupName: ["477"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/451/page",
        name: "(중대)산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["451"],
      },
      {
        name: "비상조치 처리 절차",
        icon: "w-line",
        submenu: [
          {
            url: "/filelibrary/454",
            name: "상황별 비상 대비 시나리오",
            activeCode: "filelibrary-454",
            icon: "w-line",
            groupName: ["454"],
          },
          {
            url: "/filelibrary/455",
            name: "사고별·시간별 시나리오",
            activeCode: "filelibrary-455",
            icon: "w-line",
            groupName: ["455"],
          },
          {
            url: "/",
            name: "비상사태 시나리오",
            activeCode: "",
            icon: "w-line",
            // groupName: [""],
          },
        ],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
    ],
  },
  {
    url: "/",
    name: "(중대)산업재해 발생 보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["244"],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
          {
            url: "/mypage/sign-update",
            name: "개인서명관리",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
        ],
      },
    ],
  },
];
